import type { GeocodeResult } from "@/types/address";

/**
 * 주소 → 좌표 변환 (서버 API 경유)
 */
export async function getCoordinates(address: string): Promise<GeocodeResult | null> {
  try {
    const res = await fetch("/api/address/geocode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ address }),
    });

    const data = await res.json();
    return data.success ? data.data : null;
  } catch (error) {
    console.error("좌표 변환 실패:", error);
    return null;
  }
}
